exports.computeSelectionHeight = boundingBox => boundingBox.get('height');
